import PropTypes from "prop-types";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link2, SquarePen } from "lucide-react";

import { Button } from "@/components/ui/button";
import LinkContactDialog from "routes/swoogo/LinkContactDialog";

const RegistrantTitleActions = ({ registrant, canLink, canEdit }) => {
  const navigate = useNavigate();
  const [isLinkOpen, setIsLinkOpen] = useState(false);
  const hasContact = registrant.contact_id != null;

  return (
    <>
      {canEdit && (
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate(`/swoogo/registrants/${registrant.id}/edit`)}
        >
          <SquarePen data-icon="inline-start" />
          Edit
        </Button>
      )}
      {canLink && (
        <Button variant="outline" size="sm" onClick={() => setIsLinkOpen(true)}>
          <Link2 data-icon="inline-start" />
          {hasContact ? "Change Contact" : "Link Contact"}
        </Button>
      )}
      {isLinkOpen && (
        <LinkContactDialog
          registrant={registrant}
          open
          onOpenChange={setIsLinkOpen}
        />
      )}
    </>
  );
};

RegistrantTitleActions.propTypes = {
  registrant: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    contact_id: PropTypes.number,
    contact_name: PropTypes.string,
  }).isRequired,
  canLink: PropTypes.bool,
  canEdit: PropTypes.bool,
};

export default RegistrantTitleActions;
